import axiosClient from './axiosClient';

/** Endpoints for the authenticated CLIENT role (/api/v1/client/**). */
const clientService = {
  getProfile: () => axiosClient.get('/client/profile'),
  updateProfile: (payload) => axiosClient.put('/client/profile', payload),
  uploadProfilePicture: (file) => {
    const form = new FormData();
    form.append('file', file, file.name);
    return axiosClient.post('/client/profile/picture', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getDashboard: () => axiosClient.get('/client/dashboard'),

  // Bookings
  createBooking: (payload) => axiosClient.post('/client/bookings', payload),
  listBookings: (params = {}) => axiosClient.get('/client/bookings', { params }),
  getBooking: (id) => axiosClient.get(`/client/bookings/${id}`),
  cancelBooking: (id, notes) =>
    axiosClient.patch(`/client/bookings/${id}/status`, { status: 'CANCELLED', notes }),

  // Reviews
  createReview: (payload) => axiosClient.post('/client/reviews', payload),
  listReviews: (params = {}) => axiosClient.get('/client/reviews', { params }),
};

export default clientService;
